import "core-js/modules/es.array.push.js";
import { mapState } from 'vuex';
export default {
  props: {
    mute: Boolean,
    devicePeerId: [String, Number],
    mainWindowDeviceType: [String, Number],
    slotNum: [String, Number],
    behaviorInfo: Object,
    output: Boolean,
    anywherePopShow: Boolean,
    devicePlatform: [String, Number],
    bookLiveInfos: Object,
    degreeHost: [String, Number],
    nickName: String,
    avatar: String,
    tagName: String,
    userInfo: Object,
    talkbackStatus: Boolean,
    fullScreenInfo: Boolean,
    isAudioLevel: {
      type: Boolean,
      default() {
        return true;
      }
    },
    controlMute: {
      default: ''
    },
    rtcLoaded: {
      type: Boolean,
      default: false
    },
    devicesInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
    outputRtilCode: {
      type: [String, Number],
      default: ''
    },
    selectRids: {
      type: String,
      default: ''
    },
    allRList: {
      type: Object,
      default: () => {
        return {};
      }
    },
    singChannel: {
      type: Object,
      default: () => {
        return {};
      }
    },
    title: {
      type: [String, Number],
      default: null
    },
    theme: {
      type: String,
      validator: function (value) {
        if (['success', 'danger'].includes(value)) {
          return value;
        }
        return '';
      }
    },
    volume: {
      type: Object,
      default: function () {
        return {
          level: 0
        };
      }
    },
    muteVideo: {
      // 是否默认关闭摄像头
      type: Boolean,
      default: true
    },
    muteAudio: {
      // 是否默认静音
      type: Boolean,
      default: true
    },
    liveInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
    needStartVoip: {
      type: Boolean,
      default: false
    },
    sourceId: {
      type: String,
      default: ''
    },
    rtc: {
      type: Object,
      default: () => {
        return {};
      }
    },
    remoteNetWorks: {
      type: Object,
      default: () => {
        return {};
      }
    },
    hearSelf: {
      type: Boolean,
      default: false
    },
    sourceType: {
      type: String,
      default: ''
    },
    leftRightRtilCode: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      mainWindowList: [{
        label: 'receiver',
        value: 'receiver'
      }, {
        label: 'producer',
        value: 'producer'
      }, {
        label: 'pack',
        value: 'pack'
      }, {
        label: 'mediaHub',
        value: 'mediaHub'
      }, {
        label: 'channel',
        value: 'channel'
      }],
      getReceiverParams: {
        pageNum: 1,
        pageSize: 400,
        living: true,
        offline: false,
        online: true,
        queryCollaborate: true
      },
      getRListTimer: null,
      receiverList: [],
      origin: '',
      tvuOne: false,
      selectRid: '',
      isFullScreen: false,
      listInfo: {}
    };
  },
  created() {
    if (this.allRList) {
      this.newFormatRList(this.allRList, true);
    }
  },
  computed: {
    ...mapState({
      State: state => state,
      logoGray: state => state.logoGray
    }),
    btnList() {
      let array = ['fullScreen', 'removeParticipant'];
      if (this.outputRtilCode == this.singChannel.id) {
        array = array.filter(featureName => {
          return featureName != 'removeParticipant';
        });
      }
      return array;
    },
    controlMuteVideo() {
      if (this.talkbackStatus) {
        return this.controlMute;
      } else {
        return '';
      }
    },
    returnVideoClass() {
      let _str = '';
      this.isFullScreen ? _str += 'isFullScreen' : '';
      if (!this.State.showFootBar && this.isFullScreen) {
        _str += ' notShowFootBar';
      }
      return _str;
    }
  },
  watch: {
    'State.speakerStatus': {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal[this.outputRtilCode] == false || newVal[this.outputRtilCode]) {
          this.$emit('operatCallback', {
            type: 'muteMainWindowAudio',
            id: this.outputRtilCode,
            val: !!newVal[this.outputRtilCode]
          });
        }
      }
    },
    selectRids: {
      immediate: true,
      handler(val) {
        this.selectRid = val;
      }
    },
    fullScreenInfo(newVal, oldVal) {
      if (!newVal && oldVal) this.isFullScreen = false;
    },
    allRList(val) {
      if (!this.allRList) return;
      this.newFormatRList(val, true);
    },
    singChannel: {
      immediate: true,
      handler(newValue, oldValue) {
        if (!newValue || !newValue.info) {
          return;
        }
        if (newValue.audioTrack && this.outputRtilCode) {
          this.$set(this.State.speakerStatus, this.outputRtilCode, this.mute);
          if (this.mute) {
            this.singChannel.audioTrack.setVolume(0);
          } else {
            this.singChannel.audioTrack.setVolume(100);
          }
        }
      }
    }
  },
  methods: {
    setSpeaker() {
      this.$refs.attendUser && this.$refs.attendUser.setSpeakerAttendUser();
    },
    callbackByLiveSource({
      type,
      filter,
      rid,
      from,
      val,
      value
    }) {
      if (type == 'getReceiverList' && !filter) {
        if (val) {
          this.getReceiverParams.pageNum = 1;
          this.getRList(filter, from);
        }
      } else if (type == 'getReceiverList' && filter) {
        if (this.getRListTimer) clearTimeout(this.getRListTimer);
        this.getRListTimer = setTimeout(() => {
          this.getRList(filter, from, val);
        }, 500);
      } else if (type == 'changeSource') {
        if (typeof rid === 'string') {
          this.selectRid = rid;
        } else {
          this.selectRid = rid[1];
        }
      } else if (type === 'loadNextPage') {
        var _this$listInfo$cc;
        if ((_this$listInfo$cc = this.listInfo.cc) !== null && _this$listInfo$cc !== void 0 && _this$listInfo$cc.hasNextPage) {
          this.getReceiverParams.pageNum++;
          this.getRList('', from, '', 'loadNextPage');
        }
      } else if (type === 'initPageNum') {
        this.getReceiverParams.pageNum = 1;
      } else if (type == 'startlive') {
        this.$emit('callBack', value);
      }
    },
    setBookLive(obj) {
      this.$emit('setBookLive', obj);
    },
    controlAudioChannel() {
      if (this.singChannel.id == this.userInfo.rtilCode) {
        this.$refs.attendUser.reUseAudioWorklet();
      }
    },
    changeFullScreenVal(val) {
      var _this$$refs$attendUse;
      (_this$$refs$attendUse = this.$refs.attendUser) === null || _this$$refs$attendUse === void 0 ? void 0 : _this$$refs$attendUse.changeFullScreenVal(val);
    },
    showTalkbackTitle(haveSetTalkback) {
      let _str = '';
      const _this = this;
      haveSetTalkback ? _str = this.$t('commonSetting.offLazyAudioTips') : _str = this.$t('commonSetting.turnOnLazy');
      if (_this.liveInfo.peerId && _this.liveInfo.peerId.includes('fffff')) {
        _str = this.$t('addWords.producerNotSupport');
      }
      return _str;
    },
    attendCallback(obj) {
      const {
        type,
        val
      } = obj;
      if (type === 'fullScreen') {
        this.isFullScreen = val;
      }
      this.$emit('operatCallback', obj);
    },
    getRList(filter, from, val, loadNextPage) {
      let params = null;
      if (filter) {
        params = {
          living: true,
          offline: false,
          online: true,
          queryCollaborate: true,
          condition: val
        };
      } else {
        params = this.getReceiverParams;
      }
      this.axios.post('/partyline-backend/receiver/v3/page', params).then(res => {
        if (!res) return;
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          this.listInfo = result;
          if (from) {
            this.newFormatRList(result, filter, loadNextPage);
          }
          this.$emit('changeRList', result);
        }
      });
    },
    dealPPList(list) {
      const array = [];
      this.State.ppRlist = [];
      list.forEach(item => {
        item.pageInfo.list.forEach(info => {
          this.State.slotList = info.ridSlotList;
          this.State.ppRlist.push(info);
          const ppObj = {};
          ppObj.value = info.receiverId;
          ppObj.label = info.name;
          ppObj.userInfo = item.user;
          ppObj.productionId = info.id;
          if (info.ridSlotList) {
            ppObj.children = info.ridSlotList.map((item, index) => {
              return {
                value: item.rid,
                label: `Slot${item.slotNo.replace('s', '')}`
              };
            });
          }
          array.push(ppObj);
        });
      });
      return array;
    },
    // 封装多级联动需要的数据
    newFormatRList(result, filter, loadNextPage) {
      var _result$cc, _result$cc$list;
      if (JSON.stringify(result) == '{}') return;
      const array = [];
      result = JSON.parse(JSON.stringify(result));
      // receiver list
      const receiverObj = {};
      if (loadNextPage) {
        receiverObj.children = this.receiverList[0].children;
      } else {
        this.State.ccIdList = [];
        receiverObj.children = [];
      }
      receiverObj.value = 'Receiver';
      receiverObj.label = 'Receiver';
      if ((_result$cc = result.cc) !== null && _result$cc !== void 0 && (_result$cc$list = _result$cc.list) !== null && _result$cc$list !== void 0 && _result$cc$list.length) {
        result.cc.list.forEach(item => {
          this.State.ccIdList.push(item.peerId);
          const itemInfo = {
            ...item,
            value: item.peerId,
            label: item.name
          };
          receiverObj.children.push(itemInfo);
        });
      } else {
        receiverObj.disabled = true;
      }
      // 最新需求 R 也可以添加成为与会者, 所以需要把当前的 R 从列表中删除
      if (this.sourceType === 'R') {
        receiverObj.children = receiverObj.children.filter(item => item.peerId !== this.singChannel.devicePeerId);
      }
      array.push(receiverObj);
      // pp list
      this.State.slotList = [];
      const ppObj = {};
      ppObj.value = 'Producer';
      ppObj.label = 'Producer';
      if (result.pps && result.pps.length) {
        ppObj.children = this.dealPPList(result.pps);
      } else {
        ppObj.disabled = true;
      }
      array.push(ppObj);
      if (filter) {
        this.receiverList = array;
      } else {
        this.receiverList = array;
      }
    }
  }
};